<template>
	<b-container fluid>
		<b-row>
			<b-col>
				<card>
					<PunctualityReportTable></PunctualityReportTable>
				</card>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
import PunctualityReportTable from '@/components/Report/PunctualityReportTable.vue';

export default {
	name: 'PunctualityReport',
	components: {
		PunctualityReportTable
	}
};
</script>
